(function () {
  if (window.__glAddonCartPriceSyncInitialized) return;

  window.__glAddonCartPriceSyncInitialized = true;

  function getSectionDataElement() {
    return document.querySelector(
      'script[data-section-type="static-cart"][data-section-id]',
    );
  }

  function replaceContents(currentRoot, refreshedRoot, selector) {
    var currentElements = currentRoot.querySelectorAll(selector);
    var refreshedElements = refreshedRoot.querySelectorAll(selector);

    currentElements.forEach(function (currentElement, index) {
      if (refreshedElements[index]) {
        currentElement.innerHTML = refreshedElements[index].innerHTML;
      }
    });
  }

  function groupRowsByVariant(rows) {
    var groupedRows = Object.create(null);

    rows.forEach(function (row) {
      var variantId = row.getAttribute('data-cartitem-id');

      if (!groupedRows[variantId]) groupedRows[variantId] = [];
      groupedRows[variantId].push(row);
    });

    return groupedRows;
  }

  function renderCartPrices(html) {
    if (typeof html !== 'string' || !html) return false;

    var refreshedDocument = new DOMParser().parseFromString(html, 'text/html');
    var currentRows = Array.from(document.querySelectorAll('[data-cartitem]'));
    var refreshedRows = Array.from(refreshedDocument.querySelectorAll('[data-cartitem]'));
    var refreshedRowsByVariant = groupRowsByVariant(refreshedRows);

    if (refreshedRows.length === 0) return false;

    currentRows.forEach(function (currentRow) {
      var variantId = currentRow.getAttribute('data-cartitem-id');
      var matchingRows = refreshedRowsByVariant[variantId];
      var refreshedRow = matchingRows && matchingRows.shift();

      if (!refreshedRow) return;

      [
        'data-cartitem-id',
        'data-cartitem-key',
        'data-cartitem-line',
        'data-cartitem-price',
        'data-cartitem-available',
      ].forEach(function (attribute) {
        if (refreshedRow.hasAttribute(attribute)) {
          currentRow.setAttribute(attribute, refreshedRow.getAttribute(attribute));
        } else {
          currentRow.removeAttribute(attribute);
        }
      });

      replaceContents(currentRow, refreshedRow, '.cart-item--content');
      replaceContents(currentRow, refreshedRow, '.cart-item__total');
    });

    replaceContents(document, refreshedDocument, '[data-cart-total]');

    document.dispatchEvent(
      new CustomEvent('gl.custom.euroPriceFormat', {
        detail: {
          container: document.querySelector('form[aria-label]') || document.body,
        },
      }),
    );

    return true;
  }

  window.glCartPriceSync = {
    refresh: function () {
      var sectionDataElement = getSectionDataElement();

      if (!sectionDataElement) {
        return Promise.reject(new Error('Cart section ID was not found'));
      }

      var requestUrl = new URL(window.location.href);
      requestUrl.searchParams.delete('sections');
      requestUrl.searchParams.set('section_id', sectionDataElement.dataset.sectionId);
      requestUrl.searchParams.set('_addon_cart_price_sync', String(Date.now()));

      return fetch(requestUrl.toString(), {
        credentials: 'same-origin',
        cache: 'no-store',
        headers: { Accept: 'text/html' },
      })
        .then(function (response) {
          if (!response.ok) {
            throw new Error('Cart section request failed: ' + response.status);
          }
          return response.text();
        })
        .then(function (html) {
          if (!renderCartPrices(html)) {
            throw new Error('Cart section did not contain refreshed item prices');
          }
        });
    },
  };
})();
